

export default {
    backend: 'https://cuentame.firmamex.com'
}